import { render, staticRenderFns } from "./accordion.html?vue&type=template&id=115e0d0a&"
import script from "./accordion.js?vue&type=script&lang=js&"
export * from "./accordion.js?vue&type=script&lang=js&"
import style0 from "./accordion.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports